import { Component } from '@angular/core';
import { PageLayoutComponent } from '../../components/page-layout/page-layout.component';
import { QueueStatsComponent } from '../../components/queue-stats/queue-stats.component';

@Component({
  selector: 'app-queue-stats-page',
  standalone: true,
  imports: [PageLayoutComponent, QueueStatsComponent],
  templateUrl: './queue-stats-page.component.html',
  styleUrl: './queue-stats-page.component.scss',
})
export class QueueStatsPageComponent {}
